<template>
  <div class="stationery-list">
    <el-table
      ref="multipleTable"
      :data="stationeryList"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      class="common-edit-button"
    >
      <el-table-column label="#" type="index"> </el-table-column>
      <el-table-column
        prop="itemName"
        label="文具名称"
        width="150px"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="quantity"
        label="数量"
        width="120px"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column label="操作" width="185px">
        <template slot-scope="scope">
          <div class="handle-container">
            <!-- 修改 -->
            <el-button
              type="warning"
              icon="el-icon-edit"
              @click="editClick(scope.row)"
              size="small"
              v-hasPermi="'sc:schoolstationery:edit'"
              >修改
            </el-button>
            <!-- 删除 -->
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="deleteClick(scope.row)"
              size="small"
              v-hasPermi="'sc:schoolstationery:delete'"
              >删除</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 修改文具信息 -->
    <stationeryEdit
      v-show="editStationeryShow"
      :editStationeryShow.sync="editStationeryShow"
      :stationeryData="stationeryData"
    />
  </div>
</template>

<script>
import stationeryEdit from "../stationery-edit/stationeryEdit";
export default {
  components: {
    stationeryEdit,
  },
  data() {
    return {
      title: "",
      stationeryData: {},
      editStationeryShow: false,
    };
  },
  inject: ["refresh"],
  props: {
    stationeryList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    handleSelectionChange(val) {
      // console.log(val);
      this.selectList = val;
      let list = [];
      this.selectList.forEach((item) => {
        list.push(item.id);
      });
      this.$emit("multipleDelete", list);
    },
    // 点击编辑
    editClick(item) {
      // console.log(item);
      this.stationeryData = item;
      this.editStationeryShow = true;
    },
    // 点击删除
    deleteClick(item) {
      // console.log(item);
      this.$confirm("是否删除该文具?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // 调用删除学生信息接口
          let list = [];
          list.push(item.id);
          this.delete(this.$url.deleteSchoolStationery + "?ids=" + list)
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success("删除成功");
                // 刷新列表
                this.refresh();
              }
            })
            .catch((err) => {
              // console.log(err);
              this.$message.error("删除失败，请稍后重试");
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./stationeryList.scss";
</style>
